export default {
    merch: {
        list: []
    },
    currIndex: 0,
   
}